import type { EditableImageListRecord } from '../../types/index.ts';
import type { MultiImageUploaderProps } from '../MultiImageUploader/index.ts';
import type { FormComponentProps } from './types.ts';
import { MultiImageUploader } from '../MultiImageUploader/index.ts';
import { useFieldContext } from './BaseForm.ts';
import { useMergeHandleChangeAndBlur, usePropsFromField } from './utils.ts';

export function FormMultiImageUploader(
  props: FormComponentProps<Omit<MultiImageUploaderProps, 'onChange' | 'value'>>
) {
  const field = useFieldContext<EditableImageListRecord[]>();

  const handleChangeAndBlur = useMergeHandleChangeAndBlur(field.handleChange, field.handleBlur);

  return (
    <MultiImageUploader
      key={field.name}
      {...usePropsFromField(props, field)}
      onChange={handleChangeAndBlur}
      value={field.state.value}
    />
  );
}
